'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import NewsSearchListSkeleton from '../../../molecules/NewsSearchList/NewsSearchListSkeleton';
import QueryProviderClient from '@fe-news/context/query-provider';
import useMediaQuery from '@fe-news/hooks/use-media-query';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';

const DynamicColumnistList = dynamic(() => import('./ColumnistList'), {
  loading: () => <NewsSearchListSkeleton />,
  ssr: false
});

const CARD_HEIGHT_FOR_DESKTOP = 150;
const CARD_HEIGHT_FOR_MOBILE = 194;

const DynamicLoadCelebrityList: React.FC<ColumnistListProps> = props => {
  const isDesktop = useMediaQuery(`(min-width:${SCREEN_SIZE.DESKTOP}px)`);

  const cardHeight = isDesktop ? CARD_HEIGHT_FOR_DESKTOP : CARD_HEIGHT_FOR_MOBILE;

  return (
    <QueryProviderClient>
      <Suspense>
        <DynamicColumnistList cardHeight={cardHeight} {...props} />
      </Suspense>
    </QueryProviderClient>
  );
};

export default DynamicLoadCelebrityList;
